import { DocumentNode } from 'graphql';
import Cookies from 'js-cookie';
import { IToken } from '@modules/auth/domain/model/auth.model';
import { IFavoriteRepository } from '@modules/favorite/application/ports/favorite.repository.port';
import { FavoriteType, GetMemberFavoriteResultQueryDocument, TabNameForMemberFavoriteResult, UpdateMemberFavoriteDocument, UpdateMemberFavoriteResponse } from '@modules/libs/graphql/generated/graphql';
import { gqlMutate, gqlQuery } from '@modules/libs/graphql/gql-config';
import { getAuthCookiesName } from '@shared/helpers/getAuthCookiesName.helper';
import { left, right } from '@shared/utils/either.utils';
import { AllFavoriteItemEntityMapper } from '../../outbound/ports/allFavoriteItem.mapper';
export class FavioriteRepositoryImpl implements IFavoriteRepository {
  async getFavoriteItemById(query: DocumentNode, itemIds: Object, responseKey: string): IFavoriteRepository.getFavoriteOutput {
    try {
      const cookies = Cookies.get(getAuthCookiesName());
      const tokens = cookies && JSON.parse(cookies) as IToken;
      const {
        data
      } = await gqlQuery({
        query,
        headers: {
          authorization: tokens.jwt ? `Bearer ${tokens.jwt}` : ''
        },
        variables: {
          data: itemIds
        }
      });
      return right(data[responseKey].length > 0);
    } catch (error: any) {
      console.error('error IFavoriteRepository.getFavoriteItemById', error);
      return left(error);
    }
  }
  async updateFavoriteItemById(id: number, favoriteType: FavoriteType): IFavoriteRepository.updateFavoriteOutput {
    try {
      const cookies = Cookies.get(getAuthCookiesName());
      const tokens = cookies && JSON.parse(cookies) as IToken;
      const {
        data
      } = await gqlMutate({
        mutation: UpdateMemberFavoriteDocument,
        headers: {
          authorization: tokens.jwt ? `Bearer ${tokens.jwt}` : ''
        },
        variables: {
          data: {
            favoriteType,
            idOfFavoriteItem: id
          }
        }
      });
      return right((data.updateMemberFavorite as UpdateMemberFavoriteResponse).isFavorite);
    } catch (error: any) {
      console.error('error IFavoriteRepository.updateFavoriteItemById', error);
      return left(error);
    }
  }
  async getAllFavoriteItemByType(type: TabNameForMemberFavoriteResult): IFavoriteRepository.getAllFavoriteByTypeOutput {
    try {
      const cookies = Cookies.get(getAuthCookiesName());
      const tokens = cookies && JSON.parse(cookies) as IToken;
      const {
        data,
        errors
      } = await gqlQuery({
        query: GetMemberFavoriteResultQueryDocument,
        headers: {
          authorization: tokens.jwt ? `Bearer ${tokens.jwt}` : ''
        },
        variables: {
          where: {
            tab: type
          }
        }
      });
      if (errors) throw errors[0].message ?? 'Unknow Error';
      return AllFavoriteItemEntityMapper.toDomain(data.getMemberFavoriteResult);
    } catch (error: any) {
      console.error('error IFavoriteRepository.getAllFavoriteItemByType', error);
      throw {
        data: error,
        message: error.message,
        statusCode: error.graphQLErrors[0].extensions.code
      };
    }
  }
}